import {
  openManageDelegationModal as manageDelegationModal,
  openSwitchProfileModal as switchProfileModal,
  type UserDelegatesModalProps,
  type SwitchProfileModalProps,
} from '@workboard/ui-user-delegates';

const onToast: UserDelegatesModalProps["onToast"] = (event) => {
  if (event.type && event.message) {
    toastr?.[event.type]?.(event.message);
  }
};

function openManageDelegationModal(props: UserDelegatesModalProps) {
  if (!window.wbConfig?.isUserRoleDelegationEnabled) {
    return;
  }
  const modalProps = props ?? {} as UserDelegatesModalProps;
  manageDelegationModal?.({
    ...modalProps,
    userId: +window.uData.user_id,
    onToast,
  });
}

function openSwitchProfileModal(props: SwitchProfileModalProps) {
  if (!window.wbConfig?.isUserRoleDelegationEnabled) {
    return;
  }
  const modalProps = props ?? {} as SwitchProfileModalProps;
  switchProfileModal?.({
    ...modalProps,
    onToast,
  });
}


window.openManageDelegationModal = openManageDelegationModal;
window.openSwitchProfileModal = openSwitchProfileModal;